import { RequestEndorseSubject } from './request-endorse-subject.model';

export class Endorse {
  materias: RequestEndorseSubject[];
  justificacionAvalados: String;
  justificacionNoAvalados: String;
  numeroActa: String;
  fechaActa: String;
  autorizador: String;
}

